import {Button, Form, Input} from 'antd';
import {getLogin} from '../api/Api';
import {useState} from 'react';

export const Login = ({onSuccessfulLogin, onFailedLogin}) => {

    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");
    const [loginMsg, setLoginMsg] = useState("");

    const onUserChange = (e) => {
        setUser(e.target.value);
    }

    const onPasswordChange = (e) => {
        setPassword(e.target.value);
    }

    const onFinish = () => {

        getLogin(user, password).then((x) => {
            if ((x) && (onSuccessfulLogin)) {
                onSuccessfulLogin(x);
            } else {
                onFailedLogin();
                setLoginMsg('Login Failed');
                setTimeout(()=> {
                    setLoginMsg("");
                }, 5000);
            }
        }).catch((e) => {
            console.log(`error ${e}`);
        });
    }

    const onFinishFailed = () => {
        console.log(`failed`);
    }

    return <div style = {{marginLeft: 200, marginRight: 200}}>
        <Form
            name="basic"
            labelCol={{span: 4}}
            wrapperCol={{span: 20}}
            initialValues={{remember: true}}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >
            <Form.Item
                label="Username"
                name="username"
                rules={[{required: true, message: 'Please input your username!'}]}
            >
                <Input onChange={onUserChange}/>
            </Form.Item>

            <Form.Item
                label="Password"
                name="password"
                rules={[{required: true, message: 'Please input your password!'}]}
            >
                <Input.Password onChange={onPasswordChange} />
            </Form.Item>

            <Form.Item label={null}>
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
            </Form.Item>
        </Form>
        <div style={{color: 'red'}}>{loginMsg}</div>
    </div>
}